import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';
import { getAccessLinkRoute } from '@confluence/ssr-app/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import type { getUniquePageLoadId } from '@confluence/unique-page-load-id/entry-points/UniquePageLoadId.ts';

import { ContentExtensionsProvider } from '../../ContentExtensionsProvider/index.ts';

export const AccessLinkRoute: {
	({ params: { shareToken }, hash }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				attributes: {
					isPublicView: boolean;
					isAccessLinkView: boolean;
					pageLoadInfo: ReturnType<typeof getUniquePageLoadId>;
				};
			};
			pageState: {
				routeName: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = getAccessLinkRoute({
	ContextProvider: ContentExtensionsProvider,
	NotFound,
});
